<template>
  <div class="wrapper">
    <div class="main-panel">
      <div class="main-content">
        <div class="content-wrapper">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <a class="btn btn-secondary float-right" href="/users/new"
                  >New</a
                >
                <h2 class="content-header">{{ $t("labels.users") }}</h2>
              </div>
            </div>
            <!--Responsive tables Starts-->
            <section id="responsive">
              <div class="row">
                <div class="col-sm-12">
                  <div class="card">
                    <div class="card-header"></div>
                    <div class="card-body">
                      <div class="card-block">
                        <table class="table table-responsive-sm">
                          <thead>
                            <tr>
                              <th>First name</th>
                              <th>Last name</th>
                              <th>Email</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="user in users" :key="user._id">
                              <td>{{ user.name }}</td>
                              <td>{{ user.surname }}</td>
                              <td>{{ user.email }}</td>
                              <td>
                                <a
                                  class="success p-0"
                                  data-original-title=""
                                  title=""
                                  @click="editUser(user._id)"
                                >
                                  <i
                                    class="fa fa-pencil font-medium-3 mr-2"
                                  ></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <!--Responsive tables Ends-->
          </div>
        </div>
      </div>
      <dev-footer />
    </div>
  </div>
</template>

<script>
import UserService from "../../services/user";
import DevFooter from "../DevFooter";
export default {
  components: {
    DevFooter,
  },
  data: () => {
    return {
      users: [],
    };
  },
  mounted: async function () {
    await this.loadUsers();
  },
  methods: {
    loadUsers: async function () {
      try {
        let result = await UserService.index();
        this.users = result.data;
      } catch (e) {
        this.$miniToastr.error(e, "Error");
      }
    },
    editUser: function (userId) {
      window.location.href = `/app/users/${userId}/edit`;
    },
  },
};
</script>
